import { RuleProps } from 'types/application';

export const CONTACT_PUB = 'pub-details';

export const PUB_CONTACT_DETAILS_FIELDS = [
    {
        sectionID: CONTACT_PUB,
        sectionName: '',
        fieldList: [
            {
                id: 'email',
                label: 'Email Address',
                type: 'email',
                rule: { required: true, charLength: 320 }
            },
            {
                id: 'mobile-no',
                label: ' Mobile No.',
                type: 'combo',
                rule: { required: true },
                preField: {
                    id: 'country-code',
                    label: 'Coutry Code',
                    apiID: 'MobileNoCountryCode',
                    type: 'dropdown',
                    options: [{ optID: '65', optLabel: '+65' }],
                    defaultValue: '65'
                },
                mainField: {
                    id: 'main',
                    type: 'number',

                    rule: {
                        baseIds: [`${CONTACT_PUB}-mobile-no-country-code`],
                        required: true,
                        pattern: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${CONTACT_PUB}-mobile-no-country-code`] === '65');
                            return isSG ? /^[89][0-9]{7}$/ : undefined;
                        },
                        charLength: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${CONTACT_PUB}-mobile-no-country-code`] === '65');
                            return isSG ? 8 : 12;
                        }
                    }
                }
            },
            {
                id: 'office-no',
                label: 'Office No.',
                type: 'combo',
                rule: { required: true },
                preField: {
                    id: 'country-code',
                    label: 'Coutry Code',
                    apiID: 'OfficeNoCountryCode',
                    type: 'dropdown',
                    options: [{ optID: '65', optLabel: '+65' }],
                    defaultValue: '65'
                },
                mainField: {
                    id: 'main',
                    type: 'number',

                    rule: {
                        baseIds: [`${CONTACT_PUB}-office-no-country-code`],
                        required: true,
                        pattern: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${CONTACT_PUB}-office-no-country-code`] === '65');
                            return isSG ? /^[3689][0-9]{7}$/ : undefined;
                        },
                        charLength: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${CONTACT_PUB}-office-no-country-code`] === '65');
                            return isSG ? 8 : 12;
                        }
                    }
                }
            },

            {
                id: 'address-type',
                label: 'Address Type',
                apiID: 'AddressType',
                type: 'dropdown',
                options: [{ optID: 'SG', optLabel: 'Singapore' }],
                defaultValue: 'SG',
                rule: { required: true, disabled: true }
            },
            {
                id: 'postal',
                label: 'Postal Code',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'dropdown',
                rule: { required: true, charLength: 10 }
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: { required: true, charLength: 32 }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: { charLength: 66 }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                placeholder: 'Eg: 01, B1, 01M',
                rule: { charLength: 3 }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                placeholder: 'Eg: #05-01, use 01',
                rule: { charLength: 5 }
            }
        ]
    }
];
